module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"recordWasStopped":"По какой-то причине запись была прервана","chooseOption":"Выберите один из подходящих вариантов","resumeOfficeInterview":"Продолжить запись","overwrite":"Записать заново","save":"Сохранить"}}')
  delete Component.options._Ctor
}
